// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"c7813717","94":"ca4b5766","120":"d87dc1e1","126":"91856564","171":"75b6864b","407":"6e2ad2a0","432":"ea4377bf","532":"f2f411d0","674":"80f31060","684":"de3d2a2d","711":"8f8bc283","744":"a25005bc","994":"79ee9eaa"}[chunkId] + ".chunk.js";
};